// extracted by mini-css-extract-plugin
export default {"copy-text":"CopyText_copy-text__J5kHE","copy-text__main-text":"CopyText_copy-text__main-text__M1O4i","copy-text__copied":"CopyText_copy-text__copied__ToAfU"};